<template>
  <div class="orders-list-table">
    <!--    <el-table :data="dataList" :max-height="heightStr" ref="multipleTable" @selection-change="onSelectionChange">-->
    <el-table :data="dataList" ref="multipleTable" @selection-change="onSelectionChange" :row-class-name="tableRowClassName">
      <template v-for="{ type, prop, label, width, slot, align, fixed } in config">
        <el-table-column :key="prop" :label="label" :type="type" :min-width="width" :align="align" v-if="type"></el-table-column>
        <el-table-column :key="prop" :prop="prop" :label="label" :min-width="width" :fixed="fixed" :align="align" v-else-if="slot">
          <template slot-scope="scope">
            <p v-if="slot === 'html'" v-html="scope.row.goodsNo + '<br>' + scope.row.categoryName"></p>
            <template v-if="slot === 'caozuo'">
              <!-- z-index 递减 上层 覆盖 下层 -->
              <div class="item item2":style="{
                zIndex: 100 - scope.$index,
              }">
                <div class="hint_pr-operation">
                  <template v-if="typeStr === 'all'">
                    <el-popover
                      placement="bottom"
                      width="120"
                      popper-class="caozuo-popover"
                      trigger="hover">
                      <ul >
                        <li >
                          <label @click="
                        toOtherPages(
                          scope.row.subsetStatus == '99' &&
                            scope.row.applierName == userInfo.reallyName
                            ? 'modify_order'
                            : 'orderDetails',
                          scope.row,
                          'modify_order')">查看/编辑</label>
                        </li>
                        <!-- 0:申诉中 1:撤销 2:通过 3:驳回 4:被修改 -->
                        <!-- 本人才可以发起 v-if="scope.row.applierName == userInfo.reallyName" 且有提成类型  且申诉中 且申述通过不可以 且曾经通过-->
                        <li v-if="scope.row.applierName == userInfo.reallyName && scope.row.bonusTypeLabel && scope.row.bonusReviewStatus !==0 && scope.row.bonusReviewStatus !==2 && scope.row.isAppealPass !==1" >
                          <label  @click="onTableShowDialog('发起提成申诉','650px','faqishensu',scope.row,scope.$index)" >发起提成申诉</label>
                        </li>
                        <li v-if="scope.row.bonusReviewStatusLabel" >
                          <template v-if="scope.row.bonusReviewStatus === 4">
                            <!-- 被修改提成 -->
                            <label @click="onTableShowDialog('查看修改证明','640px','chakanshensu',scope.row,scope.$index)" >查看修改证明</label>
                          </template>
                          <template v-else>
                            <!-- 有审核状态才有 查看提成申诉  bonusReviewStatusLabel -->
                            <label @click="onTableShowDialog('查看提成申诉','640px','chakanshensu',scope.row,scope.$index)" >查看提成申诉</label>
                          </template>
                        </li>
                        <li v-if="scope.row.bonusReviewStatusLabel">
                          <!-- 有审核状态才有 申诉记录 bonusReviewStatusLabel -->
                          <label @click="onTableShowDialog('申诉记录','640px','shensujilu',scope.row,scope.$index)"  >申诉记录</label>
                        </li>
                        <!-- 申诉中不能修改 bonusReviewStatus：0  && parArrayArr.indexOf('fqxgtc') != -1-->
                        <li v-if="scope.row.bonusReviewStatus!==0 && parArrayArr.indexOf('fqxgtc') != -1 ">
                          <label @click="onTableShowDialog('发起修改提成','640px','shensuxiugai',scope.row,scope.$index)">发起修改提成</label>
                        </li>
                      </ul>
                      <label slot="reference" class="show-block" >操作<i class="el-icon-arrow-down"></i></label>
                    </el-popover>
                  </template>
                  <template v-if="typeStr === 'close'">
                    <label @click="
                      toOtherPages(
                        'orderDetails',
                        scope.row,
                        'modify_order'
                      )
                      ">查看/编辑</label>
                  </template>
                  <!-- 申诉审核中 -->
                  <template v-else-if="typeStr === 'bonusIng'">
                    <el-popover
                      placement="bottom"
                      width="120"
                      popper-class="caozuo-popover"
                      trigger="hover">
                      <ul >
                        <li>
                          <label @click="onTableShowDialog('查看提成申诉','640px','chakanshensu',scope.row,scope.$index)" >查看提成申诉</label>
                        </li>
                        <li>
                          <label @click="onTableShowDialog('申诉记录','640px','shensujilu',scope.row,scope.$index)" >申诉记录</label>
                        </li>
                      </ul>
                      <label slot="reference" class="show-block" >操作<i class="el-icon-arrow-down"></i></label>
                  </el-popover>
                  </template>
                  <!-- 申诉驳回 -->
                  <template v-else-if="typeStr === 'bonusReject'">
                    <el-popover
                        placement="bottom"
                        width="120"
                        popper-class="caozuo-popover"
                        trigger="hover">
                      <ul >
                        <!--  本人才可以发起 v-if="scope.row.applierName == userInfo.reallyName 且曾经通过不能申诉" -->
                        <li @click="onTableShowDialog('发起提成申诉','650px','faqishensu',scope.row,scope.$index)" v-if="scope.row.applierName == userInfo.reallyName && scope.row.isAppealPass !==1" >
                          <label>发起提成申诉</label>
                        </li>
                        <li>
                          <label @click="onTableShowDialog('查看提成申诉','640px','chakanshensu',scope.row,scope.$index)" >查看提成申诉</label>
                        </li>
                        <li>
                          <label @click="onTableShowDialog('申诉记录','640px','shensujilu',scope.row,scope.$index)" >申诉记录</label>
                        </li>
                        <!-- 有权限才能发起 parArrayArr.indexOf('fqxgtc') != -1-->
                        <li  @click="onTableShowDialog('发起修改提成','640px','shensuxiugai',scope.row,scope.$index)" v-if="parArrayArr.indexOf('fqxgtc') != -1">
                          <label>发起修改提成</label>
                        </li>
                      </ul>
                      <label slot="reference" class="show-block" >操作<i class="el-icon-arrow-down"></i></label>
                    </el-popover>
                  </template>
                  <!-- 申诉通过 -->
                  <template v-else-if="typeStr === 'bonusSuccess'">
                    <el-popover
                        placement="bottom"
                        width="120"
                        popper-class="caozuo-popover"
                        trigger="hover">
                    <ul >
                      <li>
                        <label @click="onTableShowDialog('查看提成申诉','640px','chakanshensu',scope.row,scope.$index)" >查看提成申诉</label>
                      </li>
                      <li>
                        <label @click="onTableShowDialog('申诉记录','640px','shensujilu',scope.row,scope.$index)" >申诉记录</label>
                      </li>
                      <!-- 有权限才能发起 parArrayArr.indexOf('fqxgtc') != -1-->
                      <li  @click="onTableShowDialog('发起修改提成','640px','shensuxiugai',scope.row,scope.$index)" v-if="parArrayArr.indexOf('fqxgtc') != -1">
                        <label>发起修改提成</label>
                      </li>
                    </ul>
                    <label slot="reference" class="show-block" >操作<i class="el-icon-arrow-down"></i></label>
                  </el-popover>
                  </template>
                  <!-- 被改提成 -->
                  <template v-else-if="typeStr === 'bonusEdit'">
                    <el-popover
                        placement="bottom"
                        width="120"
                        popper-class="caozuo-popover"
                        trigger="hover">
                      <ul >
                        <li>
                          <label @click="onTableShowDialog('申诉记录','640px','shensujilu',scope.row,scope.$index)" >申诉记录</label>
                        </li>
                        <li @click="onTableShowDialog('查看修改证明','640px','chakanshensu',scope.row,scope.$index)" >
                          <label>查看修改证明</label>
                        </li>
                        <!--  本人才可以确认 且状态等于未确认 v-if="scope.row.applierName == userInfo.reallyName" -->
                        <li @click="onTableShowDialog('确认修改','640px','confirmModify',scope.row,scope.$index)" v-if="scope.row.applierName == userInfo.reallyName && scope.row.bonusKnowFlag===0">
                          <label>确认修改</label>
                        </li>
                      </ul>
                      <label slot="reference" class="show-block" >操作<i class="el-icon-arrow-down"></i></label>
                    </el-popover>
                  </template>
                  <template v-else-if="typeStr === 'close'">
                    <label @click="
                      toOtherPages(
                        'orderDetails',
                        scope.row,
                        'modify_order'
                      )
                      ">查看/编辑</label>
                  </template>
                  <template v-else-if="typeStr === 'operation'">
                    <label @click="
                      toOtherPages(
                        scope.row.subsetStatus == '99' &&
                          scope.row.applierName == userInfo.reallyName
                          ? 'modify_order'
                          : 'orderDetails',
                        scope.row,
                        'saleAfter'
                      )
                      ">查看</label>
                  </template>
                  <!-- 如果待提交的按钮，只有本人有-->
                  <template v-else-if="typeStr == 'submitted'">
                    <el-popover
                        placement="bottom"
                        width="120"
                        popper-class="caozuo-popover"
                        trigger="hover">
                      <ul>
                        <li v-if="isShowCom.detail">
                          <label @click="
                            toOtherPages(
                              scope.row.subsetStatus == '99' &&
                                scope.row.applierName == userInfo.reallyName
                                ? 'modify_order'
                                : 'orderDetails',
                              scope.row,
                              'modify_order'
                            )
                            ">查看/编辑</label>
                        </li>
                        <li v-if="isShowCom.cancelOrder">
                          <label @click="cancelOrderWait(scope.row)">取消订单</label>
                        </li>
                        <li v-if="isShowCom.cancelOrderMsg &&
                          scope.row.applierName == userInfo.reallyName &&
                          scope.row.subsetStatus == 3
                        ">
                          <label @click="cancelOrderMsg(scope.row)">取消订单</label>
                        </li>
                        <li v-if="isShowCom.submitOrder">
                          <label @click="onResubmitOrder(scope.row.orderId)">提交订单</label>
                        </li>
                        <li v-if="isShowCom.submitOrderAgain &&
                          scope.row.applierName == userInfo.reallyName &&
                          scope.row.approveStatus == 3
                        ">
                          <label @click="onResubmitOrder(scope.row.orderId)">重新提交</label>
                        </li>
                        <li v-if="isShowCom.examineProcess">
                          <label @click="
                            onTableShowDialog(
                              '审核流程',
                              '640px',
                              'shenheStep',
                              scope.row,
                              scope.$index
                            )
                            ">审核流程</label>
                        </li>
                        <!-- <li v-if="isShowCom.examineProcess"><label @click="toOtherPages('orderDetails', scope.row, 'orderDetails')">查看/编辑</label></li>-->
                        <li v-if="isShowCom.seeExpress">
                          <label @click="
                            onTableShowDialog(
                              '查看物流',
                              '500px',
                              'logisticsMessageOne',
                              scope.row,
                              scope.$index
                            )
                            ">查看物流</label>
                        </li>
                        <li v-if="isShowCom.modifyExpress">
                          <label @click="
                            onTableShowDialog(
                              '修改快递单号',
                              '500px',
                              'modifyOrderNoOne',
                              scope.row,
                              scope.$index
                            )
                            ">修改快递单号</label>
                        </li>
                        <li v-if="isShowCom.confirmReceipt">
                          <label @click="onConfirmReceipt(scope.row)">确认收货</label>
                        </li>
                        <li v-if="isShowCom.copyExpress">
                          <label @click="copyInfo(scope.row, 'express')">复制物流单号</label>
                        </li>
                      </ul>
                      <label slot="reference" class="show-block" v-show="scope.row.applierName == userInfo.reallyName">操作<i class="el-icon-arrow-down"></i></label>
                    </el-popover>
                  </template>
                  <!-- 审核订单列表操作按钮 -->
                  <template v-else-if="typeStr == 'auditOrder'">
                    <el-popover
                        placement="bottom"
                        width="120"
                        popper-class="caozuo-popover"
                        trigger="hover">
                      <ul>
                        <li>
                          <label @click="
                            toOtherPages(
                              'orderDetails',
                              scope.row,
                              'examination'
                            )
                            ">查看</label>
                        </li>
                        <li>
                          <label @click="
                            onTableShowDialog(
                              '审核流程',
                              '640px',
                              'shenheStep',
                              scope.row,
                              scope.$index
                            )
                            ">进度</label>
                        </li>
                        <li v-if="scope.row.approveStatus == 1 &&
                          scope.row.canDoApprove == 1
                        ">
                          <label @click="
                            onTableShowDialog(
                              '审核',
                              '640px',
                              'shenheList',
                              scope.row,
                              false
                            )
                            ">审核</label>
                        </li>
                        <!--                      <li v-if="scope.row.approveStatus == 1"><label @click="onTableShowDialog('审核', '640px', 'shenheList', scope.row, false)">{{scope.row.applierName}}审核{{userInfo.reallyName}}</label></li>-->
                      </ul>
                      <label slot="reference">操作<i class="el-icon-arrow-down"></i></label>
                    </el-popover>
                  </template>
                  <!-- 提成申诉审核 列表操作按钮 -->
                  <template v-else-if="typeStr == 'commissionOrder'">
                    <el-popover
                        placement="bottom"
                        width="120"
                        popper-class="caozuo-popover"
                        trigger="hover">
                      <ul>
                        <li>
                          <label @click="
                            toOtherPages(
                              'orderDetails',
                              scope.row,
                              'examinationCommission'
                            )
                            ">查看订单</label>
                        </li>
                        <li>
                          <!-- 审核列表，都可以查看 查看申诉状态 -->
                          <template v-if="scope.row.auditStatus === 4">
                            <label @click="onTableShowDialog('查看修改证明','640px','chakanshensu',scope.row,scope.$index)" >查看修改证明</label>
                          </template>
                          <template v-else>
                            <label @click="onTableShowDialog('查看提成申诉','640px','chakanshensu',scope.row,scope.$index)" >查看提成申诉</label>
                          </template>
                        </li>
                        <li v-if="scope.row.auditStatus === 0">
                          <!-- 只有申诉中才有 审核 -->
                          <label @click="onTableShowDialog('提成申诉审核','640px','auditshensu',scope.row,false)">审核</label>
                        </li>
                        <li>
                          <label @click="onTableShowDialog('申诉记录','640px','shensujilu',scope.row,scope.$index)" >申诉记录</label>
                        </li>
                        <!--                      <li v-if="scope.row.approveStatus == 1"><label @click="onTableShowDialog('审核', '640px', 'shenheList', scope.row, false)">{{scope.row.applierName}}审核{{userInfo.reallyName}}</label></li>-->
                      </ul>
                      <label slot="reference">操作<i class="el-icon-arrow-down"></i></label>
                    </el-popover>
                  </template>
                  <template v-else-if="typeStr == 'recordList'">
                    <el-popover
                        placement="bottom"
                        width="120"
                        popper-class="caozuo-popover"
                        trigger="hover">
                      <ul>
                        <li>
                          <label @click="
                            toOtherPages(
                              'afterSaleDetails',
                              scope.row,
                              'Details'
                            )
                            ">查看</label>
                        </li>
                        <li v-if="scope.row.afterSaleStepCode == 1">
                          <label @click="
                            onTableShowDialog(
                              '审核流程',
                              '640px',
                              'shenheStep',
                              scope.row,
                              scope.$index
                            )
                            ">进度</label>
                        </li>
                        <li v-if="scope.row.afterSaleStepCode == 1 &&
                          scope.row.canDoApprove == 1
                        ">
                          <label @click="
                            onTableShowDialog(
                              '审核',
                              '640px',
                              'afterSaleShenhe',
                              scope.row,
                              scope.$index
                            )
                            ">审核</label>
                        </li>
                        <!--                      <li v-if="scope.row.afterSaleStepCode!='6'&&scope.row.afterSaleStepCode!='7'&&scope.row.afterSaleStepCode!='8'&&(scope.row.createdUserName === userInfo.reallyName || userInfo.id === 1)">-->
                        <li v-if="parArrayArr.indexOf('chsh') != -1 &&
                          scope.row.afterSaleStepCode != 8
                        ">
                          <label @click="
                            revocationAfterSales(
                              '撤回售后',
                              '640px',
                              'cancelService',
                              scope.row.afterNo
                            )
                            ">撤回售后</label>
                        </li>
                        <li v-if="scope.row.afterSaleStepCode == 3">
                          <label @click="
                            onTableShowDialog(
                              '物流信息-退货',
                              '640px',
                              'progress',
                              scope.row,
                              scope.$index
                            )
                            ">查看退货物流</label>
                        </li>
                        <li v-if="scope.row.afterSaleStepCode == 3 &&
                          (scope.row.createdUserName === userInfo.reallyName ||
                            userInfo.id === 1)
                        ">
                          <label @click="
                            onTableShowDialog(
                              '修改退货单号',
                              '500px',
                              'modifyOrderNoOneTui',
                              scope.row,
                              scope.$index
                            )
                            ">修改退货单号</label>
                        </li>
                        <li v-if="scope.row.afterSaleStepCode == 5 &&
                          parArrayArr.indexOf('after_xghhdh') != -1
                        ">
                          <label @click="
                            onTableShowDialog(
                              '修改换货单号',
                              '500px',
                              'modifyOrderNoTwo',
                              scope.row,
                              scope.$index
                            )
                            ">修改换货单号</label>
                        </li>
                        <li v-if="scope.row.afterSaleStepCode == 2 &&
                          (scope.row.createdUserName === userInfo.reallyName ||
                            userInfo.id === 1)
                        ">
                          <label @click="
                            onTableShowDialog(
                              '退货单号',
                              '500px',
                              'modifyOrderNoOneTui',
                              scope.row,
                              scope.$index
                            )
                            ">退货单号</label>
                        </li>
                        <li v-if="scope.row.afterSaleStepCode == 4 &&
                          parArrayArr.indexOf('order_huanhuojichu') != -1
                        ">
                          <label @click="
                            onTableShowDialog(
                              '换货寄出',
                              '500px',
                              'modifyOrderNoTwo',
                              scope.row,
                              scope.$index
                            )
                            ">换货寄出</label>
                        </li>
                        <li v-if="scope.row.afterSaleStepCode == 5">
                          <label @click="
                            onTableShowDialog(
                              '物流信息-换货',
                              '640px',
                              '2',
                              scope.row
                            )
                            ">查看换货物流</label>
                        </li>
                        <li v-if="(scope.row.afterSaleStepCode == 3 ||
                          scope.row.afterSaleStepCode == 5) &&
                          (scope.row.createdUserName === userInfo.reallyName ||
                            userInfo.id === 1 ||
                            parArrayArr.indexOf('main_confirmReceipt_wuliu') !=
                            -1)
                        ">
                          <label @click="onConfirmTake(scope.row)">确认收货</label>
                        </li>
                        <li v-if="parArrayArr.indexOf('After_sales_registration') != -1">
                          <label @click="
                            openLoginDialog(
                              scope.row,
                              scope.$index
                            )
                            ">售后件登记</label>
                        </li>
                        <li v-if="parArrayArr.indexOf('Registration_history') != -1">
                          <label @click="
                            openLoginDialogRecord(
                              scope.row,
                              scope.$index
                            )
                            ">登记记录</label>
                        </li>
                      </ul>
                      <label slot="reference">操作<i class="el-icon-arrow-down"></i></label>
                    </el-popover>
                  </template>
                  <!-- 售后订单操作按钮 -->
                  <template v-else-if="typeStr == 'afterOrder'">
                    <label @click="
                      toOtherPages(
                        'afterSaleRecordList',
                        scope.row,
                        'afterOrder'
                      )
                      ">售后记录</label>
                  </template>
                  <template v-else>
                    <el-popover
                      placement="bottom"
                      width="120"
                      popper-class="caozuo-popover"
                      trigger="hover">
                    <ul v-if="typeStr !== 'all' && typeStr !== 'close'">
                      <li v-if="isShowCom.detail">
                        <label @click="
                          toOtherPages(
                            scope.row.subsetStatus == '99' &&
                              scope.row.applierName == userInfo.reallyName
                              ? 'modify_order'
                              : 'orderDetails',
                            scope.row,
                            'modify_order'
                          )
                          ">查看/编辑</label>
                      </li>
                      <li v-if="isShowCom.cancelOrder">
                        <label @click="cancelOrderWait(scope.row)">取消订单</label>
                      </li>
                      <li v-if="isShowCom.cancelOrderMsg &&
                        scope.row.applierName == userInfo.reallyName &&
                        scope.row.subsetStatus == 3
                      ">
                        <label @click="cancelOrderMsg(scope.row)">取消订单</label>
                      </li>
                      <li v-if="isShowCom.submitOrder">
                        <label @click="onResubmitOrder(scope.row.orderId)">提交订单</label>
                      </li>
                      <li v-if="isShowCom.submitOrderAgain &&
                        scope.row.applierName == userInfo.reallyName &&
                        scope.row.approveStatus == 3
                      ">
                        <label @click="onResubmitOrder(scope.row.orderId)">重新提交</label>
                      </li>
                      <li v-if="isShowCom.examineProcess">
                        <label @click="
                          onTableShowDialog(
                            '审核流程',
                            '640px',
                            'shenheStep',
                            scope.row,
                            scope.$index
                          )
                          ">审核流程</label>
                      </li>
                      <!-- <li v-if="isShowCom.examineProcess"><label @click="toOtherPages('orderDetails', scope.row, 'orderDetails')">查看/编辑</label></li>-->
                      <li v-if="isShowCom.seeExpress">
                        <label @click="
                          onTableShowDialog(
                            '查看物流',
                            '500px',
                            'logisticsMessageOne',
                            scope.row,
                            scope.$index
                          )
                          ">查看物流</label>
                      </li>
                      <li v-if="isShowCom.modifyExpress">
                        <label @click="
                          onTableShowDialog(
                            '修改快递单号',
                            '500px',
                            'modifyOrderNoOne',
                            scope.row,
                            scope.$index
                          )
                          ">修改快递单号</label>
                      </li>
                      <li v-if="isShowCom.confirmReceipt">
                        <label @click="onConfirmReceipt(scope.row)">确认收货</label>
                      </li>
                      <li v-if="isShowCom.copyExpress">
                        <label @click="copyInfo(scope.row, 'express')">复制物流单号</label>
                      </li>
                      <!-- 发货前 待签收 已完成 插入提成相关按钮 -->
                      <template v-if="typeStr == 'beforeShipment' || typeStr == 'waitSignFor' || typeStr == 'finish' ">
                        <!-- 0:申诉中 1:撤销 2:通过 3:驳回 4:被修改 -->
                        <!-- 本人才可以发起 v-if="scope.row.applierName == userInfo.reallyName" 且有提成类型  且申诉中 且申述通过不可以 且曾经通过不可以-->
                        <li v-if="scope.row.applierName == userInfo.reallyName && scope.row.bonusTypeLabel && scope.row.bonusReviewStatus !==0 && scope.row.bonusReviewStatus !==2 && scope.row.isAppealPass !==1 " >
                          <label  @click="onTableShowDialog('发起提成申诉','650px','faqishensu',scope.row,scope.$index)" >发起提成申诉</label>
                        </li>
                        <li v-if="scope.row.bonusReviewStatusLabel" >
                          <template v-if="scope.row.bonusReviewStatus === 4">
                            <!-- 被修改提成 -->
                            <label @click="onTableShowDialog('查看修改证明','640px','chakanshensu',scope.row,scope.$index)" >查看修改证明</label>
                          </template>
                          <template v-else>
                            <!-- 有审核状态才有 查看提成申诉  bonusReviewStatusLabel -->
                            <label @click="onTableShowDialog('查看提成申诉','640px','chakanshensu',scope.row,scope.$index)" >查看提成申诉</label>
                          </template>
                        </li>
                        <li v-if="scope.row.bonusReviewStatusLabel">
                          <!-- 有审核状态才有 申诉记录 bonusReviewStatusLabel -->
                          <label @click="onTableShowDialog('申诉记录','640px','shensujilu',scope.row,scope.$index)"  >申诉记录</label>
                        </li>
                        <!-- 申诉中不能修改 bonusReviewStatus：0  && parArrayArr.indexOf('fqxgtc') != -1-->
                        <li v-if="scope.row.bonusReviewStatus!==0 && parArrayArr.indexOf('fqxgtc') != -1 ">
                          <label @click="onTableShowDialog('发起修改提成','640px','shensuxiugai',scope.row,scope.$index)">发起修改提成</label>
                        </li>
                      </template>
                    </ul>
                    <label slot="reference" class="show-block" v-if="typeStr !== 'all' && typeStr !== 'close'">操作<i class="el-icon-arrow-down"></i></label>
                  </el-popover>
                  </template>
                </div>
              </div>
            </template>
            <template v-if="slot === 'goods'">
              <!-- z-index 递减 上层 覆盖 下层 -->
              <div class="item item-line" :style="{
                zIndex: 3,
                minWidth: tableWith
              }">
                <div v-if="scope.row.orderNo" style="padding-top: 2px;">
                  <label class="tooltip" aria-label="点击复制" @click="copyInfo(scope.row, 'all')">订单编号：{{ scope.row.orderNo
                    }}</label>
                  <label class="relation-order" v-if="typeStr !== 'operation'">关联订单号：{{
                    scope.row.platformOrderNo
                      ? scope.row.platformOrderNo
                      : "-"
                  }}</label>
                  <!--  v-if="scope.row.platformOrderNo"  -->
                </div>
                <div v-if="scope.row.afterNo" style="padding-top: 2px;">
                  <label class="tooltip" aria-label="点击复制" @click="copyInfo(scope.row, 'afterOrder')">售后编号：{{
                    scope.row.afterNo }}</label>
                </div>
                <div class="hint_font" v-if="routeObj.name === 'ordersList' ||
                  routeObj.name === 'operatorsOrderList' || (scope.row.submitDate && isShowTime.submitDate)
                ">
                  客户：{{ scope.row.userName }}（{{ scope.row.userPhone }}）<br>
                  提交审核时间：{{
                    scope.row.status == 99 ? "-" : scope.row.submitDate
                  }}
                </div>
                <!-- <div v-if="scope.row.submitDate && isShowTime.submitDate" class="hint-time hint_pr ">
                  
                </div> -->
                <div class="hint_pr" v-if="routeObj.name === 'operatorsOrderList'">
                  订单类型：{{ scope.row.orderTypeLabel }}
                </div>
                <div class="hint_pr" v-if="routeObj.name === 'operatorsOrderList'">
                  业绩归属人：{{ scope.row.achievementUserName }}
                </div>
                <div v-if="scope.row.applierName" class="hint_pr tooltip" aria-label="点击复制" @click="copyInfo(scope.row, 'service')">
                  跟进客服：{{ scope.row.applierName }}
                </div>
                <!-- 提成申诉审核页才显示 -->
                <!-- <div v-if="$route.name === 'examinationCommissionList'" class="hint_pr" >
                  提交审核时间：{{ scope.row.applyTime }}
                </div> -->
                <!--<div v-if="scope.row.submitDate" class="hint_pr">{{typeStr==='auditOrder'?'提交时间':'下单时间'}}：{{ scope.row.submitDate }}</div>-->
                <div v-if="scope.row.createdTime && isShowTime.createdTime" class="hint_pr">
                  {{ typeStr === "operation" ? "提交时间" : "下单时间" }}：{{
                    scope.row.createdTime
                  }}
                </div>
                <div class="hint_pr" >
                  资源来源：{{ scope.row.platformName || '-' }}
                </div>
              </div>
              <!-- v-if="typeStr === 'operation'" -->
              <template v-if="afterSale === 'afterSale'">
                <div v-if="scope.row.afterRecords">
                  <div class="mesSty" v-for="(item, index) in scope.row.afterRecords" :key="index">
                    <!-- <img class="imgSty" src="https://dummyimage.com/72x54/FF6600" alt="">-->
                    <div style="margin-bottom: 6px">
                      <span style="font-weight: bold">售后编号：</span>{{ item.afterNo }}
                    </div>
                    <el-image :src="item.goodsImage" fit="cover"></el-image>
                    <div class="mesFont">
                      <p :title="item.goodsName + '*' + item.quantity">
                        <span>{{ item.goodsName }}</span>
                      </p>
                      <p>{{ item.goodsSkuName }} * {{ item.quantity }}</p>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-if="scope.row.details">
                  <div class="mesSty" v-for="(item, index) in scope.row.details" :key="index">
                    <!-- <img class="imgSty" src="https://dummyimage.com/72x54/FF6600" alt="">-->
                    <el-image :src="item.goodsImage" fit="cover"></el-image>
                    <div class="mesFont">
                      <p :title="item.goodsName + '*' + item.quantity">
                        <span>{{ item.goodsName }}</span>
                      </p>
                      <p>{{ item.goodsSkuName }} * {{ item.quantity }}</p>
                    </div>
                  </div>
                </div>
              </template>
              <div>
                <div class="mesSty" v-if="!scope.row.details">
                  <el-image :src="scope.row.goodsImage" fit="cover"></el-image>
                  <div class="mesFont">
                    <p :title="scope.row.goodsName + '*' + scope.row.quantity">
                      <span>{{ scope.row.goodsName }}</span>
                    </p>
                    <p>
                      {{ scope.row.goodsSkuName }} * {{ scope.row.quantity }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="slot === 'contact'">
              <p style="height: 23px;">{{ scope.row.postName }}</p>
              <p style="height: 23px;">{{ scope.row.postContact }}</p>
            </template>

            <template v-if="slot === 'address'">
              <p class="address">{{ scope.row.postDetailedAddress }}</p>
              
            </template>
            
            <template v-if="slot === 'amount'">
              <template v-if="typeStr === 'operation'">
                <p style="height: 23px;">总价：￥{{ scope.row.totalAmount }}</p>
              </template>
              <template v-else>
                <p style="height: 23px;">总价：{{ scope.row.totalAmount }}</p>
                <p style="height: 23px;">已收：{{ scope.row.receivedAmount }}</p>
                <p style="height: 23px;">代收：{{ scope.row.collectionAmount }}</p>
              </template>
            </template>
            <!-- 运营订单-售后单 -->
            <template v-if="afterSale === 'afterSale'">
              <template v-if="slot === 'totalAmount'" v-for="(item, index) in scope.row.afterRecords">
                <div class="afterSaleAmount">
                  <p style="height: 23px;">实付：￥{{ item.totalAmount }}</p>
                  <p style="height: 23px;">退款：￥{{ item.refundAmount }}</p>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-if="slot === 'totalAmount'">
                <p style="height: 23px;">实付：￥{{ scope.row.totalAmount }}</p>
                <p style="height: 23px;">退款：￥{{ scope.row.refundAmount }}</p>
              </template>
            </template>
            <template v-if="slot === 'shenheMessage'">
              <p style="height: 23px;">
                审核人：{{
                  scope.row.approverName ? scope.row.approverName : "-"
                }}
              </p>
              <p style="height: 23px;">{{ scope.row.approverTime ? scope.row.approverTime : "-" }}</p>
            </template>
            <template v-if="slot === 'notGo'">
              <p style="height: 23px;">{{ scope.row.rejectReason ? scope.row.rejectReason : "-" }}</p>
            </template>
            <template v-if="slot === 'order' && typeStr !== 'operation'">
              <p :title="scope.row.subsetSatusLabel" style="height: 23px;">
                <i v-bind:class="[
                  { 'danger-bg': scope.row.status == 99 },
                  { 'warning-bg': scope.row.status == 3 },
                  'round',
                ]"></i>
                {{ scope.row.subsetSatusLabel }}
              </p>
            </template>
            <!-- 运营订单-售后单 -->
            <template v-if="afterSale === 'afterSale'">
              <template v-if="slot === 'order' && typeStr === 'operation'" v-for="(item, index) in scope.row.afterRecords">
                <div class="afterSaleStatus">
                  <p :title="scope.row.statusLabel">
                    <i v-bind:class="[
                      { 'danger-bg': scope.row.status == 99 },
                      { 'warning-bg': scope.row.status < 4 },
                      'round',
                      { 'success-bg': scope.row.status === 4 },
                    ]"></i>
                    {{ scope.row.statusLabel }}
                  </p>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-if="slot === 'order' && typeStr === 'operation'">
                <p :title="scope.row.statusLabel">
                  <i v-bind:class="[
                    { 'danger-bg': scope.row.status == 99 },
                    { 'warning-bg': scope.row.status < 4 },
                    'round',
                    { 'success-bg': scope.row.status === 4 },
                  ]"></i>
                  {{ scope.row.statusLabel }}
                </p>
              </template>
            </template>
            <template v-if="afterSale === 'afterSale'">
              <template v-if="slot === 'afterSaleReason' && typeStr === 'operation'" v-for="(item, index) in scope.row.afterRecords">
                <div class="afterSaleStatus">
                  <p v-for="(it, el) in dictionaries.after_sale_reason" v-if="it.dictId == item.reason">
                    {{ it.dictName }}
                  </p>
                </div>
              </template>
            </template>
            <template v-if="afterSale === 'afterSale'">
              <template v-if="slot === 'approverInfo' && typeStr === 'operation'" v-for="(item, index) in scope.row.afterRecords">
                <div class="afterSaleStatus">
                  <p style="height: 23px;">{{ item.approverName }}</p>
                  <p style="height: 23px;">{{ item.approverTime }}</p>
                </div>
              </template>
            </template>
            <template v-if="afterSale === 'afterSale'">
              <template v-if="slot === 'afterSaleStatus' && typeStr === 'operation'" v-for="(item, index) in scope.row.afterRecords">
                <p class="afterSaleStatus" v-if="item.afterSaleStep == '1'">
                  <i class="warning-bg round"></i>审核中
                </p>
                <p class="afterSaleStatus" v-if="item.afterSaleStep == '2'">
                  <i class="warning-bg round"></i>待寄回
                </p>
                <p class="afterSaleStatus" v-if="item.afterSaleStep == '3'">
                  <i class="warning-bg round"></i>退货中
                </p>
                <p class="afterSaleStatus" v-if="item.afterSaleStep == '4'">
                  <i class="warning-bg round"></i>待换货
                </p>
                <p class="afterSaleStatus" v-if="item.afterSaleStep == '5'">
                  <i class="warning-bg round"></i>换货中
                </p>
                <p class="afterSaleStatus" v-if="item.afterSaleStep == '6'">
                  <i class="warning-bg round"></i>售后关闭
                </p>
                <p class="afterSaleStatus" v-if="item.afterSaleStep == '7'">
                  <i class="danger-bg round"></i>商家拒绝售后
                </p>
                <p class="afterSaleStatus" v-if="item.afterSaleStep == '8'">
                  <i class="success-bg round"></i>售后完成
                </p>
                <!-- <p v-if="item.afterSaleStep == '6'"><i class="warning-bg"></i>售后关闭</p> -->
                <!-- <p v-if="item.afterSaleStep == '1'"><i v-bind:class="[{'danger-bg' : item.afterSaleStep == 3},{'warning-bg' : item.afterSaleStep == 1},{'round' : item.afterSaleStep}]"></i>审核中</p> -->
              </template>
            </template>
            <template v-if="afterSale === 'afterSale'">
              <template v-if="slot === 'caozuo' && typeStr === 'operation'" v-for="(item, index) in scope.row.afterRecords">
                <div class="afterSaleStatus" v-if="item.afterSaleStep == '4' || item.afterSaleStep == '5'">
                  <p style="cursor: pointer; color: #4168e7">查看寄回物流</p>
                  <!-- <el-button type="text" plain>查看寄回物流</el-button> -->
                </div>
              </template>
            </template>
            <template v-if="slot === 'examine'">
              <p :title="scope.row.approveStatusLabel">
                <i v-bind:class="[
                  { 'danger-bg': scope.row.approveStatus == 3 },
                  { 'warning-bg': scope.row.approveStatus == 1 },
                  { round: scope.row.approveStatus },
                ]"></i>
                {{
                  scope.row.approveStatusLabel
                    ? scope.row.approveStatusLabel
                    : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'bonusStatus'">
              <!-- 0-申诉审核中，1-撤销申诉，2-审核通过，3-申诉驳回，4-被改提成 -->
              <p :title="scope.row.bonusReviewStatusLabel">
                <i :class="[
                  { 'primary-bg': scope.row.bonusReviewStatus === 0 },
                  { 'info-bg': scope.row.bonusReviewStatus === 1 },
                  { 'success-bg': scope.row.bonusReviewStatus === 2 || scope.row.bonusReviewStatus === 4 },
                  { 'danger-bg': scope.row.bonusReviewStatus === 3 },
                  { round: scope.row.bonusReviewStatusLabel },
                ]"></i>
                {{
                  scope.row.bonusReviewStatusLabel
                    ? scope.row.bonusReviewStatusLabel
                    : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'auditStatus'">
              <!-- 0-申诉审核中，1-撤销申诉，2-审核通过，3-申诉驳回，4-被改提成 -->
              <p :title="scope.row.auditStatusLabel">
                <i :class="[
                  { 'primary-bg': scope.row.auditStatus === 0 },
                  { 'info-bg': scope.row.auditStatus === 1 },
                  { 'success-bg': scope.row.auditStatus === 2 || scope.row.auditStatus === 4 },
                  { 'danger-bg': scope.row.auditStatus === 3 },
                  { round: scope.row.auditStatusLabel },
                ]"></i>
                {{
                  scope.row.auditStatusLabel
                    ? scope.row.auditStatusLabel
                    : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'remarks'">
              <p v-show="typeStr !== 'operation'" :title="scope.row.remarks" style="height: 23px;">
                客服备注：{{ scope.row.remarks ? scope.row.remarks : "-" }}
              </p>
              <p :title="scope.row.userRemarks" style="height: 23px;">
                客户留言：{{
                  scope.row.userRemarks ? scope.row.userRemarks : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'bonusApply' && scope.row.orderBonusResponse">
              <p style="height: 23px;">{{ scope.row.orderBonusResponse.applyName }}</p>
              <p style="height: 23px;" :title="scope.row.orderBonusResponse.reason ? scope.row.orderBonusResponse.reason : ''">
                申诉备注：{{
                  scope.row.orderBonusResponse.reason ? scope.row.orderBonusResponse.reason : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'bonusEditPerson' && scope.row.orderBonusResponse">
              <p style="height: 23px;">{{ scope.row.orderBonusResponse.applyName }}</p>
              <p style="height: 23px;" :title="scope.row.orderBonusResponse.reason ? scope.row.orderBonusResponse.reason : ''">
                修改备注：{{
                  scope.row.orderBonusResponse.reason ? scope.row.orderBonusResponse.reason : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'auditRemarks' && scope.row">
              <p :title="scope.row.auditRemarks ? scope.row.auditRemarks : ''">
                {{
                  scope.row.auditRemarks ? scope.row.auditRemarks : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'applyReason' && scope.row">
              <p :title="scope.row.reason ? scope.row.reason : ''" style="height: 23px;">
                {{
                  scope.row.reason ? scope.row.reason : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'bonusKnow'">
              {{
                  scope.row.bonusKnowFlag==1?'已确认':'未确认'
               }}
            </template>
            <template v-if="slot === 'bonusAudit' &&  scope.row.orderBonusResponse">
              <p style="height: 23px;">{{  scope.row.orderBonusResponse.auditUserName }}</p>
              <p style="height: 23px;" v-if="scope.row.orderBonusResponse.auditUserName" :title=" scope.row.orderBonusResponse.auditRemarks ? scope.row.orderBonusResponse.auditRemarks : ''">
                备注：{{
                  scope.row.orderBonusResponse.auditRemarks ? scope.row.orderBonusResponse.auditRemarks : "-"
                }}
              </p>
            </template>
            <template v-if="slot === 'operation'">
              <p style="height: 23px;">操作人：{{ scope.row.closedPersonName }}</p>
              <p style="height: 23px;">时间：{{ scope.row.closedTime }}</p>
            </template>
            <template v-if="slot === 'orderOriginLabel'">
              <p style="text-align: left;height: 23px;">{{ scope.row.orderOriginLabel || '--' }}</p>
            </template>
            <template v-if="slot === 'afterLogin'">
              <template>
                <p style="height: 23px;">完好：{{ scope.row.intact }}</p>
                <p style="height: 23px;">破损：{{ scope.row.damaged }}</p>
                <p style="height: 23px;">漏件：{{ scope.row.missingParts }}</p>
              </template>
            </template>
            <template v-if="slot === 'afterLoginL'">
              <div v-for="(itm, inx) in scope.row.details" :key="inx" style="height: 128px;display: flex;justify-content: center;flex-direction: column;align-items: center;">
                <div>
                  <p style="height: 23px;">完好：{{ itm.intact || 0 }}</p>
                  <p style="height: 23px;">破损：{{ itm.damaged || 0 }}</p>
                  <p style="height: 23px;">漏件：{{ itm.missingParts || 0 }}</p>
                </div>

              </div>

            </template>
            <template v-if="slot === 'claimFlagLabelL'">
              <div v-for="(itm, inx) in scope.row.details" :key="inx" style="height: 128px;display: flex;justify-content: center;flex-direction: column;align-items: center;">
                <div>
                  <p style="height: 23px;">{{ itm.claimFlagLabel || '--' }}</p>
                </div>

              </div>
            </template>
            <template v-if="slot === 'claimAmountL'">
              <div v-for="(itm, inx) in scope.row.details" :key="inx" style="height: 128px;display: flex;justify-content: center;flex-direction: column;align-items: center;">
                <div>
                  <p style="height: 23px;">￥{{ itm.claimAmount || '0.00' }}</p>
                </div>

              </div>
            </template>
            <template v-if="slot === 'remarksL'">
              <div v-for="(itm, inx) in scope.row.details" :key="inx" style="height: 128px;display: flex;justify-content: center;flex-direction: column;align-items: center;">
                <div>
                  <p style="height: 23px;">{{ itm.remarks || '--' }}</p>
                </div>

              </div>
            </template>
            <template v-if="slot === 'afterTypeLabelL'">
              <div v-for="(itm, inx) in scope.row.details" :key="inx" style="height: 128px;display: flex;justify-content: center;flex-direction: column;align-items: center;">
                <div>
                  <p style="height: 23px;">{{ itm.afterTypeLabel || '--' }}</p>
                </div>

              </div>
            </template>
            <template v-if="slot === 'claimAmount'">
              <template>
                <p style="height: 23px;">￥{{ scope.row.claimAmount || '0.00' }}</p>

              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column :key="prop" :prop="prop" :label="label" :min-width="width" :align="align" v-else></el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import mixinsCommon from '../mixins/common'
import mixinsOrderList from '../mixins/mixinsOrderList'

export default {
  name: 'OrdersListTable',
  mixins: [mixinsCommon, mixinsOrderList],
  props: {
    afterSale: {
      type: String,
      default: () => ''
    },
    typeStr: {
      type: String,
      default: () => 'all'
    },
    heightStr: {
      type: String,
      default: () => '500px'
    },
    sortObj: { // 排序
      type: Object,
      default: () => {
      }
    },
    config: {
      type: Array,
      default: () => []
    },
    dataList: { // 数据列表
      type: Array,
      default: () => []
    },
    parArrayArr: { // 按钮权限
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      userInfo: {},
      operationActiveIndex: '1',
      popSty: false,
      isShowCom: {}, // 操作 按钮 组件显示 默认 全为 false
      isShowTime: {
        closedTime: false, // 关闭时间
        createdTime: false, // 下单时间
        finishedTime: false, // 审核时间
        submitDate: false, // 提交审核时间
        platformName:false // 平台名称
      },
      routeObj: {},
      tableWith:'100%'

    }
  },
  watch: {
    config: {
      handler(newVal, oldVal) {
        console.log(newVal)
      },
      deep: true
    },
    dataList: {
      handler(newVal, oldVal) {
        // console.log(newVal)
        setTimeout(_ => {
          this.resetStyle() // 样式调整
        }, 100)
      },
      deep: true
    },
    typeStr(value) {
      // console.log(value)
      this.showCom() // 操作 按钮 组件显示
    },
    afterSale: {
      handler(newVal, oldVal) {
        console.log(newVal)
      }
    },
    $route() {
      // this.testFun();
    }
  },

  mounted() {
    // console.log(this.dictionaries.after_sale_reason)
    this.$nextTick(_ => {
      // this.resetDate()
      console.log('afterSale==', this.afterSale)
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.showCom() // 操作 按钮 组件显示
      this.onShowTime()
    })
  },
  created() {
    this.routeObj = this.$route
    console.log(this.routeObj)
    console.log(this.routeObj.name === 'logisticsOrderList')
  },
  methods: {
    // 被修改提成，未确认高亮
    tableRowClassName ({ row, rowIndex }) {
      if (this.typeStr === 'bonusEdit' && row.bonusReviewStatus === 4 && row.bonusKnowFlag === 0) {
        return 'row-space warning-row'
      } else {
        return 'row-space'
      }
    },
    handleCommand(command, scope, userInfo) {
      // console.log('>>', command)
      // <el-dropdown-item command="view">查看/编辑</el-dropdown-item>
      // <el-dropdown-item command="apply">发起提成申诉</el-dropdown-item>
      // <el-dropdown-item command="viewApply">查看提成申诉</el-dropdown-item>
      // <el-dropdown-item command="cancel">撤销申诉</el-dropdown-item>
      // <el-dropdown-item command="record">申诉记录</el-dropdown-item>
      // <el-dropdown-item command="applyEdit">发起修改提成</el-dropdown-item>
      // <el-dropdown-item command="confirmEdit">确认修改</el-dropdown-item>
      if (command === 'view') {
        this.toOtherPages(scope.row.subsetStatus == '99' && scope.row.applierName == userInfo.reallyName ? 'modify_order' : 'orderDetails',
          scope.row,
          'modify_order')
      } else if (command === 'apply') {
        console.log(command)
      } else if (command === 'viewApply') {
        console.log(command)
      } else if (command === 'cancel') {
        console.log(command)
      } else if (command === 'record') {
        console.log(command)
      } else if (command === 'applyEdit') {
        console.log(command)
      } else if (command === 'confirmEdit') {
        console.log(command)
      }
    },
    resetStyle() {
      this.$nextTick(_ => {
        // 获取 所有行
        const elTableRowFirst = document.getElementsByClassName('el-table__row')
        // elTableRowFirst.forEach((item, index) => {
        //   if (index === 0) {
        //     // 获取  第一行的第二个
        //     // return console.log(item)
        //     const elTableCell = item.getElementsByClassName('el-table__cell')[1]
        //     const elTableCell5 = item.getElementsByClassName('el-table__cell')[5]
        //     const elTableCelldivCell = elTableCell5.getElementsByClassName('cell')[0]

        //     const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
        //     // console.log(relationOrder, 'relationOrder')
        //     // console.log(elTableCelldivCell, 'elTableCell5')
        //     if (!relationOrder) {
        //       elTableCell.style.paddingTop = '45px'
        //       elTableCelldivCell.setAttribute('style', '')
        //       // console.log('没找到关联订单调整 ppadding-top')
        //     } else {
        //       elTableCell.setAttribute('style', '')
        //       // elTableCelldivCell.style.marginTop = '30px'
        //     }
        //   } else {
        //     // 获取  其它行的第二个
        //     // return console.log(item)
        //     const elTableCell = item.getElementsByClassName('el-table__cell')[1]
        //     const relationOrder = elTableCell.getElementsByClassName('relation-order')[0]
        //     const mesSty = elTableCell.getElementsByClassName('mesSty')[0]
        //     if (relationOrder) {
        //       // console.log(mesSty)
        //       // mesSty.style.marginTop = '30px'
        //       // console.log('有找到关联订单', index)
        //       // elTableCell.style.paddingTop = '45px'
        //     } else {
        //       // console.log('没找到关联订单调整 ppadding-top')
        //       mesSty.setAttribute('style', '')
        //     }
        //   }
        // })
        this.tableWith= this.$refs.multipleTable.bodyWidth
        console.log('tableWith>>', this.tableWith)
      })
    },
    // 页面跳转
    toOtherPages(name, parameter, type) {
      // console.log(name, parameter, type)
      // console.log(parameter)
      // return
      let query = { id: parameter, type }
      if (type === 'category') {
        query = { category: parameter, type }
      }
      if (type === 'modify_order') {
        query = { id: parameter.orderId, orderId: parameter.orderId, orderNo: parameter.orderNo, awaitSubmit: type }
      }
      if (type === 'saleAfter') {
        let arr = parameter.afterRecords.map(item => {
          return item.afterSaleStep
        })
        query = { id: parameter.orderId, orderId: parameter.orderId, orderNo: parameter.orderNo, awaitSubmit: type, afterSale: this.afterSale, afterRecords: JSON.stringify(arr) }
      }
      if (type === 'orderDetails') {
        query = { id: parameter.orderId, orderId: parameter.orderId, orderNo: parameter.orderNo, type }
      }
      if (type === 'logistics') {
        query = { id: parameter.orderId, orderNo: parameter.orderNo, logistics: 'logistics1' }
      } // 物流
      if (type === 'afterSaleRecordList') {
        query = { orderNo: parameter.orderNo }
      }
      if (type === 'Details') {
        query = { afterNo: parameter.afterNo, orderId: parameter.orderId, id: parameter.id }
      }
      if (type === 'examination') {
        query = {
          id: parameter.id,
          orderNo: parameter.orderNo,
          approveStatus: parameter.approveStatus ? parameter.approveStatus : 1,
          audit: 'audit'
        }
      }
      if (type === 'examinationCommission') {
        query = {
          id: parameter.id,
          orderNo: parameter.orderNo,
          approveStatus: parameter.approveStatus ? parameter.approveStatus : 1,
          audit: 'audit',
          commission: 1
        }
      }// 审核
      if (type === 'afterOrder') { // 售后记录
        query = { orderNo: parameter.orderNo }
      }
      this.$router.push({ name, query })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    showCom() { // 操作 按钮 组件显示
      this.isShowCom = { // 操作 按钮 组件显示 默认 全为 false
        detail: false, // 查看/编辑
        cancelOrder: false, // 取消订单
        cancelOrderMsg: false, // 取消订单 弹窗
        submitOrder: false, // 提交订单
        submitOrderAgain: false, // 重新提交
        examineProcess: false, // 审核流程
        seeExpress: false, // 查看物流
        modifyExpress: false, // 修改快递单号
        confirmReceipt: false, // 确认收货
        copyExpress: false // 复制物流单号
      }
      const type = this.typeStr
      const userInfo = this.userInfo
      // console.log(type)
      switch (type) {
        case 'submitted': // 待提交
          this.isShowCom.detail = true // 查看/编辑
          this.isShowCom.cancelOrder = true // 取消订单
          this.isShowCom.submitOrder = true // 提交订单
          break
        case 'examine': // 审核订单
          this.isShowCom.detail = true // 查看/编辑
          this.isShowCom.examineProcess = true // 审核流程
          // 本人 + 状态
          // scope.row.applierName == userInfo.reallyName && scope.row.approveStatus == 3
          this.isShowCom.submitOrderAgain = true // 重新提交
          break
        case 'beforeShipment': // 发货前
          this.isShowCom.detail = true // 查看/编辑
          // scope.row.applierName == userInfo.reallyName && scope.row.subsetStatus == 3
          this.isShowCom.cancelOrderMsg = true // 取消订单 弹窗
          break
        case 'waitSignFor': // 待签收
          this.isShowCom.detail = true // 查看/编辑
          this.isShowCom.seeExpress = true // 查看物流
          this.isShowCom.modifyExpress = true // 修改快递单号
          this.isShowCom.confirmReceipt = true // 确认收货
          this.isShowCom.copyExpress = true // 复制物流单号
          break
        case 'finish': // 已完成
          this.isShowCom.detail = true // 查看/编辑
          this.isShowCom.copyExpress = true // 复制物流单号
          break
        case 'close': // 已关闭
          this.isShowCom.detail = true // 查看/编辑
          break
        default: // 默认
          console.log('组件显示,没有类型,默认为首页配置！')
      }
    },
    onShowTime() {
      const routeName = this.$route.name
      switch (routeName) {
        case 'ordersList': // 客服订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'examinationOrderList': // 审核订单
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleOrdeList': // 售后订单
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.submitDate = true // 提交审核时间
          break
        case 'afterSaleRecordList': // 售后记录
          break
        default:
          this.isShowTime.createdTime = true // 下单时间
          this.isShowTime.finishedTime = true // 审核时间
        // console.log('%c默认值！👀', 'color:#fff;font-size:1.2rem;padding:0.8rem 1.6rem;border-radius: 5px;background-color: #3eaf7c;font-family: "Microsoft YaHei",Arial,sans-serif;')
      }
      console.log(routeName, this.isShowTime)
    },
    openLoginDialog(row) {
      this.axios.get('/neworder/order/after/afterSalesRegistration/' + row.id).then((res) => {
        if (res.code == 0) {
          let obj = {
            loginForm: res.data,
            viewData: row
          }
          this.$emit('loginDialog', obj)
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.log(err)
        // this.btnLoading = false
      })

    },
    openLoginDialogRecord(row) {
      this.axios.get('/neworder/order/after/afterSalesRegistrationLog/' + row.id + '?' + 1).then((res) => {
        if (res.code == 0) {
          this.$emit('loginDialogRecord', res.data)
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.log(err)
        // this.btnLoading = false
      })
      // this.$emit('loginDialogRecord', row)
    },
    onTableShowDialog(title, width, type, data, batch) { // 输出 抛出 内容值 显示 dialog
      const dialogObj = { title, width, type, data, batch }
      console.log(dialogObj)
      this.$emit('onTableShowDialogCom', dialogObj)
    },
    revocationAfterSales(title, width, type, afterNo) {
      const dialogObj = { title, width, type, afterNo }
      console.log(dialogObj)
      this.$emit('onRevocationAfterSales', dialogObj)
    },
    cancelOrderMsg(row) { // 取消订单 弹窗
      this.$emit('outTableCancelOrderMsg', row)
    },
    onConfirmTake(row) {
      this.$emit('onConfirmTakeChange', row)
    },
    onSelectionChange(val) { // 多选
      // this.multipleSelection = val;
      // console.log(val)
      this.$emit('tableSelectionChange', val)
    }
  }
}
</script>

<!--<style scoped>-->
<style lang="scss" scoped>
.tooltip {
  position: relative;
  /*margin: 50px auto;*/
  /*border: 1px solid;*/
  cursor: pointer;
}

.tooltip[aria-label]:hover:after {
  content: attr(aria-label);
  position: absolute;
  bottom: -38px;
  left: 30%;
  /*border: 1px solid;*/
  width: 80px;
  text-align: center;
  border-radius: 3px;
  padding: 5px;
  color: #ffffff;
  font-size: 12px !important;
  background-color: rgba(0, 0, 0, 0.5);
}

.mesSty:after {
  clear: both;
  display: table;
  content: "";
}

/*圆点*/
.round {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  background-color: #0b7df3;
  display: inline-block;
}

.primary-bg {
  background-color: #409eff !important;
}

.success-bg {
  background-color: #12ab62 !important;
}

.warning-bg {
  background-color: #e6a23c !important;
}

.danger-bg {
  background-color: #f56c6c !important;
}

.info-bg {
  background-color: #909399 !important;
}

.el-table {
  overflow: unset;
}

::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
  background-color: #ffffff;
}

::v-deep.el-table th.el-table__cell {
  background-color: #f8f8f8;
}

::v-deep.el-table th.el-table__cell .cell {
  color: #333333;
  font-size: 14px;
}

/deep/ .el-table tr {
  position: relative;
  width: 100%;
}

/deep/ .el-table .el-table__body-wrapper {
  /*padding-top: 40px;*/
  /*overflow: unset;*/
}
/deep/ .el-table .warning-row{
  background: #fef0f0!important;
}
/deep/{
  .el-table__body .warning-row:hover >td,
  .el-table__body tr.warning-row.hover-row>td.el-table__cell{
    background: #FDE3E3!important;
  }
}
// /deep/ .el-table .warning-row:hover  > td.el-table__cell{
    // background: rgba(#f56c6c, 0.1) !important;
    // background: #fef0f0!important;
   
  // }
  /deep/ .el-table .row-space{
   clear: both;
   position: relative;
  }
  /deep/ .el-table .row-space > td {
    padding: 50px 0 0 0 !important;
    
  }
::v-deep.el-table .el-table__body .el-table__row {
  position: relative !important;
}

::v-deep.el-table .el-table__body .el-table__row:first-child {
  /*background-color: #2D7EDF;*/
}

// ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
//   position: absolute;
//   top: -8px;
//   left: 0;
//   z-index: 10000;
// }

// ::v-deep.el-table .el-table__body .el-table__row:first-child td:first-child .cell {
//   top: 3px;
// }

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(2) {
  // position: static !important;
  /*padding: 5px 0;*/
}

::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(1) {
  /*position:relative!important;*/
}

// ::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell {
//   // background-color: #0b7df3;
//   padding-top: 45px;
//   /*padding-bottom: 15px;*/
// }

// ::v-deep.orders-list-table .el-table .el-table__body .el-table__row:first-child .el-table__cell:nth-child(2) {
//   background-color: red;
//   padding-top: 50px;
//   /*padding-bottom: 15px;*/
// }

// ::v-deep.orders-list-table .el-table .el-table__body .el-table__row .el-table__cell:nth-child(2) {
//   background-color: orange;
//   padding-top: 30px;
//   /*padding-bottom: 15px;*/
// }

// ::v-deep.orders-list-table .el-table .el-table__row:first-child .el-table__cell:nth-child(2) .item {
//   /*background-color: #0b7df3;*/
//   margin-top: 0;
// }

// ::v-deep.orders-list-table .el-table .el-table__cell:nth-child(2) .item {
//   /*background-color: #0b7df3;*/
//   margin-top: -44px;
// }

.item {
  width: 100%;
  height: 45px;
  background-color: #ebeef5;
  padding: 7px 0 7px 50px;
  position: absolute;
  top: 0;
  left: 0;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}


.item>div {
  float: left;
}

.item div:first-child label:first-child {
  font-size: 14px;
  color: #4168e7;
  line-height: 10px;
  display: block;
}

.item div:first-child label:nth-child(2) {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
}
.item-line{
  left: -48px;
  
  width: calc(100vw);
}

// .hint-time{
//   position: absolute;
//   top: 0;
//   left: 1rpx;
// }
.hint_font{
  font-size: 14px;
  line-height: 16px;
  padding-left: 8vh;
}

.hint_pr {
  padding-left: 8vh;
  padding-top: 5px;
  // line-height: 20px;
}

.hint_pr-operation {
  // margin-right: 20px;
  float: right !important;
  position: relative;
  z-index: 10;
  text-align: center;
  min-width: 120px;
}

.hint_pr-operation label {
  cursor: pointer;
}

.hint_pr-operation ul {
  display: none;
  position: absolute;
  right: -14px;
  background-color: #f9f9f9;
  min-width: 100px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 1000;
  cursor: pointer;
}

.hint_pr-operation:hover ul {
  display: block;
  border-radius: 3px;
}

.hint_pr-operation ul li {
  text-align: center;
  line-height: 30px;
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
}

.hint_pr-operation ul li:last-child {
  border-bottom: none;
}

.imgSty {
  width: 80px;
  display: block;
}

.mesSty {
  /*display: flex;*/
  /*align-items: center;*/
  // margin-bottom: 8px;
  // height: 128px;
  // display: none;
  height: 54px;
  overflow: hidden;
  margin-bottom: 8px;
}

.mesSty .el-image {
  width: 72px;
  height: 54px;
  float: left;
}

.mesSty .mesFont {
  float: left;
  width: calc(100% - 100px);
  //text-align: center;
}

.mesSty .mesFont p {
  margin-block-start: 0;
  margin-block-end: 0;
  margin-left: 5px;
  color: #333333;
  /*font-size: 12px;*/
  line-height: 27px;
}

.mesSty .mesFont p:nth-child(2) {
  color: #999999;
  font-size: 12px;
}

.mesSty .mesFont p:nth-child(2) {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.address{
  width: 168px;
  height: auto;
  display: -webkit-box;
  -webkit-line-clamp: 4  !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  
  word-break: break-all;
  
}

.iconSty {
  float: right;
  cursor: pointer;
}

.item2 {
  min-width: 140px;
  height: 45px;
  padding: 7px;
  position: absolute;
  top: 0;
}

.item2 div:first-child label:first-child {
  line-height: 24px;
}

@media (min-width: 1500px) {}

@media screen and (max-width: 1500px) {
  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -32px;*/
  }
}

@media screen and (max-width: 1200px) {
  ::v-deep.el-table .el-table__body .el-table__row td:first-child .cell {
    /*top: -25px;*/
  }
}

@media (min-width: 768px) {}

.afterSaleAmount {
  margin-top: 40px;
}

.afterSaleStatus {
  margin-top: 50px;
}
</style>
<style lang="scss">
.show-block{
  width: 120px;
  display: block;
  text-align: center;
}
.caozuo-popover{
  width: 120px;
  min-width: 120px;
  box-sizing: border-box;
  padding: 0;
  ul{
    padding: 8px 10px;
  }
  li{
    text-align: center;
    line-height: 26px;
    border-bottom: 1px solid #e9e9e9;
    cursor: pointer;
    font-size: 14px;
    color: #4168e7;
    cursor: pointer;
    label{
      cursor: pointer;
    }
  }
  li:last-child {
    border-bottom: none;
  }
}
</style>